import { useLocation } from "react-router-dom";

export function useLocationWithPreviousRoute() {
  return useLocation<{ from: { pathname: string }}>();
}